import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/old-user.svg")